/**
 * smart banner, client side logic
 */
import $ from 'jquery';
import Cookies from 'js-cookie';

import { addClientIdToDeepLink } from './core/deep-link';
import { client as analyticsClient } from './tracking/common/client';

const smartBanner = {
    selectors: {
        parent: '.js-smart-banner',
        closeButton: '.js-smart-banner-close',
        buttons: '.js-smart-banner-button'
    },

    cookieKeys: {
        userClosedBanner: 'userClosedBanner'
    },

    constants: {
        daysHiddenAfterUserClosesBanner: 7
    },

    /**
     * @description bind events and display banner on initilization
     * @returns {undefined}
     */
    init: function () {
        this.$parent = $(this.selectors.parent);
        this.bindEvents();
        this.displayBanner();
    },

    /**
     * @description Bind event on click, add listener that listens to a DY event, which adds a cookie for testing.
     * @returns {undefined}
     */
    bindEvents: function () {
        $(this.selectors.closeButton).on('click', $.proxy(this.onClose, this));
        document.addEventListener('dy:smartbanner_test', () => {
            this.displayBanner();
        });
    },

    /**
     * @description Hide Banner, Set the cookie
     * @param {Event} event is used to prevent default functionality
     * @returns {undefined}
     */
    onClose: function (event) {
        event.preventDefault();
        this.hide();
        this.setCookieBannerClosed();
    },

    /**
     * @description Hide banner
     * @returns {undefined}
     */
    hide: function () {
        this.$parent.addClass('is-hidden');
    },

    /**
     * @description Show banner
     * @returns {undefined}
     */
    show: function () {
        this.$parent.removeClass('is-hidden');
    },

    /**
     * @description get clientId from Google Analytics and then add it to `deep_link` parameter on button's URL
     * @returns {undefined}
     */
    addAnalyticsClientIdToDeepLink: function () {
        analyticsClient.getClientId()
            .then((clientId) => {
                this.$parent.find(this.selectors.buttons).each((index, button) => {

                    button.href = addClientIdToDeepLink(button.href, clientId);
                });

                return clientId;
            });
    },

    /**
     * @description Set cookie for closed banned by user with an expiration date
     * @returns {undefined}
     */
    setCookieBannerClosed: function () {
        Cookies.set(this.cookieKeys.userClosedBanner, true, {
            expires: this.constants.daysHiddenAfterUserClosesBanner
        });
    },

    /**
     * @description Check if the cookie for the closed banner exists.
     * @returns {Boolean}
     */
    hasUserClosed: function () {
        return !!Cookies.get(this.cookieKeys.userClosedBanner);
    },

    /**
     * @description Check if the banner is supposed to be shown. If so, show it.
     * Otherwise keep it hidden.
     * @returns {undefined}
     */
    displayBanner: function () {
        if (!this.hasUserClosed()) {
            this.show();
            this.addAnalyticsClientIdToDeepLink();
        }
    }
};

export function init() {
    if ($(smartBanner.selectors.parent).length > 0) {
        smartBanner.init();
    }
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/home24.smartBanner.js
 **/